/* eslint-disable camelcase */
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { randomId } from '@app/constants';
import { getDeviceType } from '@app/utils';
import { Role } from '@data/sdk/match';
import { useTrackEvents } from '@data/utils/events';

export const useSignUpTracking = () => {
  const [formStarted, setFormStarted] = useState(false);
  const { i18n } = useTranslation();
  const { events, trackEvent } = useTrackEvents();

  const getCommonAttributes = () => ({
    language: i18n.language,
    device_type: getDeviceType(),
    timestamp: new Date().toISOString(),
    userId: randomId,
  });

  const trackSignUpPageView = (is_invite: boolean) => {
    trackEvent(events.TrialManagerSignUpPageView, {
      ...getCommonAttributes(),
      is_invite,
    });
  };

  const trackSignUpFormStarted = () => {
    if (formStarted) return;

    trackEvent(events.TrialManagerSignUpFormStarted, {
      ...getCommonAttributes(),
    });
    setFormStarted(true);
  };

  const trackSignUp = (email: string) => {
    const email_domain = email.split('@')[1] || '';

    trackEvent(events.TrialManagerSignUp, {
      ...getCommonAttributes(),
      role: Role.TrialManager,
      email_domain,
    });
  };

  const trackSignUpFormError = (error_message: string, error_code: string) => {
    trackEvent(events.TrialManagerSignUpFormError, {
      ...getCommonAttributes(),
      error_message,
      error_code,
    });
  };

  const trackCreateTeamPageView = () => {
    trackEvent(events.TrialManagerCreateTeamPageView, {
      ...getCommonAttributes(),
    });
  };

  const trackCreateTeam = (team_role: string) => {
    trackEvent(events.TrialManagerCreateTeam, {
      ...getCommonAttributes(),
      team_role,
    });
  };

  const trackEmailVerified = () => {
    trackEvent(events.TrialManagerEmailVerified, {
      ...getCommonAttributes(),
    });
  };

  return {
    trackSignUpPageView,
    trackSignUpFormStarted,
    trackSignUp,
    trackSignUpFormError,
    trackCreateTeamPageView,
    trackCreateTeam,
    trackEmailVerified,
  };
};
